export default __webpack_public_path__ + "static/media/fasting_window@2x.721e15bb.jpg";